import { gql, useLazyQuery } from "@apollo/client";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import IsoToDateTime, { IsoToDateWithoutTime } from "../../../CommonFunction/IsoDateTime";
import { getFields } from "../../../Utils/AllPagesQuriesAndMutations";
import { LoadTable, Loading } from "../../Components";
import { Tabs } from "../../Components/AdminRequestSupportComponents/Tabs";
import HeaderDiv from "../../Components/HeaderDiv/HeaderDiv";
import SearchBoxesDiv from "../../Components/HeaderDiv/HeaderDivComponents/SearchBoxesDiv/SearchBoxesDiv";

const MyShipment = () => {
  const [selectedCate, setSelectedCate] = useState({ Page: "OnGoing" });
  const [fetchAllLoad, { loading: queryLoading, error, data }] = useLazyQuery(
    gql`
      query TMS_TripBooking_Page($Page: String) {
        TMS_TripBooking_Page(Page: $Page) {
          _id
        }
      }
    `,
    {
      variables: selectedCate,
      fetchPolicy: "network-only",
      onCompleted: () => {
        setIsLoading(false);
      },
      onError: () => {
        setIsLoading(false);
      },
      context: {
        headers: { "X-GraphQL-Server": "secondary" },
      },
    }
  );
  const [formdata, setformdata] = useState([]);
  const Tab = useSelector((store) => store.SelectedTabData.tab);
  let Refetch = useSelector((store) => store.FormFieldData.refresh);
  const path = window.location.pathname;
  const [loadingState, setLoading] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const rights = useSelector((state) => state.userRightsReducer.userRightsData);
  const FieldWiseData = useSelector((store) => store?.ColumnManagementReducer?.tableData);
  const [Workaround, setWorkAround] = useState(false);
  const [getCurrentField, { data: fieldData }] = useLazyQuery(getFields, {
    fetchPolicy: "network-only",
  });
  const dispatch = useDispatch();
  const Key = "My_Shipments";
  let statusTab = [{ name: "Ongoing" }, { name: "POD_Pending" }, { name: "Completed" }];

  useEffect(() => {
    dispatch({ type: "TabData", payload: { tab: "Ongoing" } });
  }, []);
  useEffect(() => {
    if (Tab !== "Unread") {
      if (Tab === "Ongoing" || Tab === "Unread") {
        setSelectedCate({ Page: "OnGoing" });
      } else if (Tab === "POD_Pending") {
        setSelectedCate({ Page: "POD" });
      } else if (Tab === "Completed") {
        setSelectedCate({ Page: "Completed" });
      }
    }
  }, [Tab]);

  useEffect(() => {
    if (fieldData) {
      console.log(fieldData.GetUserTableColumnManagementWithUserId_Page_ID);

      const fields = fieldData.GetUserTableColumnManagementWithUserId_Page_ID.filter((item) => item.Status).map(
        (item) => item.Field_Name
      );
      if (fields.length > 0) {
        const constructedQuery = gql`
                  query TMS_TripBooking_Page($Page: String){
                    TMS_TripBooking_Page(Page: $Page) {
                      ${fields.join(" ")}
                    }
                  }
                `;
        fetchAllLoad({ query: constructedQuery, variables: selectedCate });
      }
    }
  }, [fieldData, fetchAllLoad, Workaround]);

  // useEffect(() => {
  //     if (Refetch) {
  //         refetch({
  //             variables: selectedCate,
  //         }).then((res) => {
  //             dispatch({ type: "Refetch", payload: false });
  //         });
  //     }

  // }, [selectedCate, Refetch]);

  useEffect(() => {
    if (Refetch || !FieldWiseData[path]?.length) {
      setLoading(true);
      if (rights[path]?.Page_Id) {
        getCurrentField({
          variables: { Table_Key: Key },
        }).then((res) => {
          setWorkAround(!Workaround);
        });
      }

      dispatch({ type: "Refetch", payload: false });
    } else if (FieldWiseData[path]?.length > 0) {
      setformdata(FieldWiseData[path]);
    }
    setLoading(false);
  }, [Refetch, FieldWiseData, rights, path, getCurrentField, dispatch, selectedCate]);

  useEffect(() => {
    let updatedData = data?.TMS_Booking_Page?.map((el) => {
      let obj = { ...el };
      delete obj.__typename;
      if (obj?.Date) {
        obj.Date = IsoToDateWithoutTime(obj?.Date);
      }
      if (obj?.createdAt) {
        obj.createdAt = IsoToDateTime(obj?.createdAt);
      }
      if (obj?.updatedAt) {
        obj.updatedAt = IsoToDateTime(obj?.updatedAt);
      }
      return obj;
    });
    setformdata(updatedData);
    setLoading(false);
  }, [data, selectedCate]);

  return (
    <div className="LoadContainer">
      <div className="HeaderDiv">
        <div>
          <p className="pageTitle">My Shipments</p>
          <div className="hr1ForPageTitle"></div>
        </div>
        <SearchBoxesDiv />
      </div>
      <Tabs tabs={statusTab} />
      <HeaderDiv title={""} />
      {isLoading ? (
        <Loading />
      ) : !formdata?.length ? (
        <p className="DataNotAvailable">Data not Available</p>
      ) : (
        <>
          {queryLoading && <div className="loader-line-div" />}
          <LoadTable title={`${Tab}`} data={formdata} loading={isLoading} error={error} />
        </>
      )}
    </div>
  );
};

export default MyShipment;
